/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    loading: false,
    showDialog: false,
    password: '',
};

const getters = {};

const actions = {
    setNewPassword({ state, commit }, ssoId) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Api.customer.setPassword(ssoId, state.password)
                .then(() => {
                    commit('resetState');
                    resolve();
                })
                .catch(() => {
                    commit('setLoading', false);
                    reject();
                });
        });
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setShowDialog(state, showDialog) {
        state.showDialog = showDialog;
    },

    setPassword(state, password) {
        state.password = password;
    },

    resetState(state) {
        state.loading = false;
        state.showDialog = false;
        state.password = '';
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
